// extracted by mini-css-extract-plugin
export default {"gradient-background":"Workflow_gradient-background__W5O5g"};